"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ArrowIcon = require("./ArrowIcon");

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ArrowIcon2.default;